import { useMap } from 'react-leaflet';
import { useEffect } from 'react';
import * as L from 'leaflet';
import 'leaflet.heat';

interface HeatmapProps {
  points: [number, number, number?][]; // [lat, lng, intensity]
}

export default function HeatmapLayer({ points }: HeatmapProps) {
  const map = useMap();

  useEffect(() => {
    const heatLayer = (L as any).heatLayer(points, {
        radius: 60,
        blur: 30,
        max: 2,
        gradient: {
            0.0: 'blue',
            0.2: 'lime',
            0.4: 'yellow',
            0.6: 'orange',
            1.0: 'red'
            }
        }).addTo(map);

    return () => {
      map.removeLayer(heatLayer);
    };
  }, [map, points]);

  return null;
}
